import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export function NoSaleAlert(props) {
  let title = "Keine Mittagstisch Zeit";
  let content = props.noSaleExplaination;
  return (
    <AlertDialog title={title} content={content} setOpen={props.setOpen} />
  );
}

export function NoDeliverAlert(props) {
  let title = "Lieferbedingungen nicht erfüllt";
  let content = props.noDeliverExplaination;
  return (
    <AlertDialog title={title} content={content} setOpen={props.setOpen} />
  );
}

export function AlertDialog(props) {
  const { setOpen } = props;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" autoFocus>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
}
